import { Modal, Button, Alert } from 'react-bootstrap';
import { AlertTriangle } from 'lucide-react';

interface DeleteConfirmModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => Promise<void>;
  isDeleting: boolean;
  tierName: string;
}

export const DeleteConfirmModal = ({ show, onHide, onConfirm, isDeleting, tierName }: DeleteConfirmModalProps) => {
  return (
    <Modal show={show} onHide={onHide} backdrop={isDeleting ? 'static' : true}>
      <Modal.Header closeButton={!isDeleting}>
        <Modal.Title>Confirm Deletion</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert variant="warning" className="d-flex align-items-start">
          <AlertTriangle size={20} className="me-2 flex-shrink-0 mt-1" />
          <div>
            <strong>Warning!</strong>
            <p className="mb-0 mt-1">
              You are about to delete the <strong>{tierName}</strong> tier. This action cannot be undone.
            </p>
          </div>
        </Alert>
        <p className="mb-0">
          <strong>Note:</strong> You cannot delete a tier that has active customers assigned to it.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isDeleting}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm} disabled={isDeleting}>
          {isDeleting ? 'Deleting...' : 'Delete Tier'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

